/**
 * Layout and Navigation Constants
 *
 * Centralized constants for responsive breakpoints, sidebar dimensions,
 * and layout-related configuration.
 */

/**
 * Responsive Breakpoints
 */
export const BREAKPOINTS = {
  /** Tablet breakpoint - sidebar collapses on screens <= this width */
  TABLET: 1024,
  /** Mobile breakpoint */
  MOBILE: 600,
} as const;

/**
 * Sidebar Configuration
 */
export const SIDEBAR = {
  /** Expanded sidebar width in pixels */
  WIDTH_EXPANDED: 246,
  /** Collapsed sidebar width in pixels */
  WIDTH_COLLAPSED: 52,
  /** Gap/margin around sidebar in pixels */
  GAP: 8,
} as const;

/**
 * LocalStorage Keys
 */
export const STORAGE_KEYS = {
  /** Key for storing sidebar expanded/collapsed state */
  SIDENAV_EXPANDED: 'sidenavExpanded',
  /** Key for storing drawer open/closed state */
  DRAWER_OPEN: 'drawerOpen',
} as const;

/**
 * Animation Durations (milliseconds)
 */
export const ANIMATION_DURATION = {
  /** Standard transition duration */
  STANDARD: 300,
  /** Fast transition duration */
  FAST: 200,
  /** Slow transition duration */
  SLOW: 500,
} as const;

/**
 * Z-Index Layers
 */
export const Z_INDEX = {
  /** Loading overlays */
  LOADING_OVERLAY: 1000,
  /** Modal dialogs */
  MODAL: 1300,
  /** Drawer/sidebar */
  DRAWER: 1200,
  /** App bar/header */
  APP_BAR: 1100,
} as const;
